import {
    GET_MAP_DIRECTIONS_START,
    GET_MAP_DIRECTIONS_SUCCESS,
    GET_MAP_DIRECTIONS_ERROR
} from '../../constants';
import { change } from 'redux-form';
import { getDistanceAndDuration } from '../../helpers/getDistanceAndDuration';

export function getMapRouteDirections({ distanceType, pickUpLocation, dropLocation }) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({
                type: GET_MAP_DIRECTIONS_START,
            });
            let bookingLocations = [], mapRouteDirections = [], mapMarkerPoints = [], directionData;
            const estimation = await getDistanceAndDuration({ distanceType, pickUpLocation, dropLocation })

            bookingLocations = estimation?.bookingLocations;
            directionData = estimation?.directions?.data?.routes?.length > 0 ? estimation?.directions?.data?.routes[0] : null;

            if (directionData) {
                ['startLocation', 'endLocation'].map((item => {
                    mapMarkerPoints.push({
                        lat: directionData?.legs[0][item]['latLng']['latitude'],
                        lng: directionData?.legs[0][item]['latLng']['longitude'],
                    })
                }))
                directionData?.legs[0].steps?.map((item) => {
                    if (item?.polyline?.encodedPolyline) {
                        const decodedPolyline = google.maps.geometry.encoding.decodePath(item?.polyline?.encodedPolyline);
                        mapRouteDirections = [...mapRouteDirections, ...decodedPolyline];
                    }
                });

                if (directionData?.viewport) {
                    await dispatch(change("ViewTracking", 'sw_lat', directionData?.viewport?.low?.latitude));
                    await dispatch(change("ViewTracking", 'sw_lng', directionData?.viewport?.low?.longitude));
                    await dispatch(change("ViewTracking", 'ne_lat', directionData?.viewport?.high?.latitude));
                    await dispatch(change("ViewTracking", 'ne_lng', directionData?.viewport?.high?.longitude));
                }

                if (mapRouteDirections?.length > 0 && mapMarkerPoints?.length > 0) {
                    await dispatch(change("ViewTracking", 'mapRouteDirections', mapRouteDirections));
                    await dispatch(change("ViewTracking", 'mapMarkerPoints', mapMarkerPoints));
                }

                dispatch({
                    type: GET_MAP_DIRECTIONS_SUCCESS,
                });
            }
            return true;
        } catch (error) {
            dispatch({
                type: GET_MAP_DIRECTIONS_ERROR,
                payload: {
                    error
                }
            });
            return false;
        }
    };
}